const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/invoices.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/invoices')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ────────────────────────────────────────────────────────────────────

type InvoiceStatus = 'draft' | 'sent' | 'paid' | 'overdue' | 'cancelled';
interface LineItem {
  description: string;
  quantity: number;
  unitPrice: number;
}
interface Invoice {
  id: string;
  invoiceNumber: string;
  customerName: string;
  customerEmail: string;
  date: string;
  dueDate: string;
  lineItems: LineItem[];
  subtotal: number;
  tax: number;
  total: number;
  status: InvoiceStatus;
  notes?: string;
  stripeInvoiceId?: string;
  stripePaymentIntent?: string;
  paymentMethod?: string;
}

// 10%

// ─── Component ────────────────────────────────────────────────────────────────